import { fa } from "element-plus/es/locale";
import {defineStore} from "pinia";

const TREAT_ACTIVE_CACHE_KEY = "treatActive"

const getTreatActiveFromCache = () => {
  const value = localStorage.getItem(TREAT_ACTIVE_CACHE_KEY)
  return value === "true"
}

const getvideoUrlFromCache = () => {
  const value = localStorage.getItem("airportVideo")
  return value === ""
}

const informationList = () => ({
    organizationData:{
      cityCode:"",
      areaCode:"",
      provinceCode:"",
    },
    cityObj:{},
    orgObj:{},
    areaObj:{},
    dateValue:[],
    waringList:{},
    warningIcon:[],
    mapPopActive:false,
    airNumberValue:"",
    uavObj:{},
    taskList:{},
    videoUrl:getvideoUrlFromCache(),
    treatActive:getTreatActiveFromCache(),
    airValueActive:1,
    //无人机远程数据
    controlObj:localStorage.getItem("controlObj") as any,
    //收缩
    contractActive:true,
    videoId:"",
    payloadIndex:"",
    identifyType:1,
    wayLineId:"",
    executionStatus:false,
})

export const informationStore = defineStore('informationStore',{
    state: informationList,
    getters: {
        getCityObj:(state) => state.cityObj,
        getAreaObj:(state) => state.areaObj,
        getorgObj:(state) => state.orgObj,
        getInputDateValue:(state) => state.dateValue,
        getwaringList:(state) => state.waringList,
        getwarningIcon:(state) => state.warningIcon,
        getInputValue:(state) => state.airNumberValue,
        getUavObj:(state) => state.uavObj,
        getTaskList:(state) => state.taskList,
        getOrganizationData:(state) => state.organizationData,
        getVideoUrl:(state) => state.videoUrl,
        getTreatActive:(state) => state.treatActive,
        getAirValueActive:(state) => state.airValueActive,
        getControlObj:(state) => state.controlObj,
        getContractActive:(state) => state.contractActive,
        getVideoId:(state) => state.videoId,
        getPayloadIndex:(state) => state.payloadIndex,
        getIdentifyType:(state) => state.identifyType,
        getWayLineId:(state) => state.wayLineId,
        getExecutionStatus:(state) => state.executionStatus,
    },
    actions: {
      async setCityObj(info:any){
        this.$state.cityObj = info
      },
      async setAreaObj(info:any){
        this.$state.areaObj = info
      },
      async setorgObj(info:any){
        this.$state.orgObj = info
      },
      async setWaringList(info:any){
        this.$state.waringList = info
      },
      async setWarningIcon(info:any){
        this.$state.warningIcon = info
      },
      async setmapPopActive(info:any){
        this.$state.mapPopActive = info
      },
      async updateInputDateValue(info:any) {
        this.$state.dateValue = info;
      },
      async updateInputValue(info:any) {
        this.$state.airNumberValue = info;
      },
      async setUavObj(info:any) {
        this.$state.uavObj = info;
      },
      async setTaskList(info:any) {
        this.$state.taskList = info;
      },
      async setOrganizationData(info:any) {
        this.$state.organizationData = info;
      },
      async setVideoUrl(info:any) {
        this.$state.videoUrl = info;
        localStorage.setItem("airportVideo", info)
      },
      async setTreatActive(info:any) {
        this.$state.treatActive = info;
        localStorage.setItem(TREAT_ACTIVE_CACHE_KEY, String(!!info))
      },
      async setAirValueActive(info:any) {
        this.$state.airValueActive = info;
      },
      async setControlObj(info:any) {
        this.$state.controlObj = info;
      },
      async setContractActive(info:any) {
        this.$state.contractActive = info;
      },
      async setVideoId(info:any) {
        this.$state.videoId = info
      },
      async setPayloadIndex(info:any) {
        this.$state.payloadIndex = info
      },
      async setIdentifyType(info:any) {
        this.$state.identifyType = info
      },
      async setWayLineId(info:any) {
        this.$state.wayLineId = info
      },
      async setExecutionStatus(info:any) {
        this.$state.executionStatus = info
      },
    }
  })